export default __webpack_public_path__ + "static/media/menu_World.21e7ae3c.svg";